const handleFulfilled = (state, action) => {
    state.status = 'succeeded';
    if (action.payload?.[0]?.type) {
        state.allWorkerStatuses = action.payload;
    } else {
        state.workerStatuses = action.payload;
    }
};

export const handleFulfilledWorkerProfileStatus = (state, action) => {
    state.status = 'succeeded';
    state.workerProfileStatusList = action.payload;
};

export {
    handleFulfilled,
};
